var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePerfectScrollbar',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.isLoading),expression:"isLoading"}],staticStyle:{"height":"calc(100dvh - 12.1rem - 30px)","background-color":"white"},attrs:{"settings":{ suppressScrollX: false }}},[_c('EnableTwoFactorAuthentications'),_c('ChangePassword')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }